import { Modal } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { journeyDataActions } from '../../../services/redux/features/journeyData.slice';

interface AdditionalServicePlanRemoveModalProps {
  isShown: boolean;
  setIsShow: React.Dispatch<React.SetStateAction<boolean>>;
}

export const AdditionalServicePlanRemoveModal: FunctionComponent<AdditionalServicePlanRemoveModalProps> = ({
  isShown,
  setIsShow,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  return (
    <Modal
      buttonCloseLabel={t('additionalServicePlan:additionalServicePlanModal.closeLabel')}
      buttonConfirmLabel={t('additionalServicePlan:additionalServicePlanModal.closeLabel')}
      buttonConfirmText={t('additionalServicePlan:additionalServicePlanModal.confirmButton')}
      buttonConfirmType="button"
      id="additionalServicePlanRemoveModal"
      onConfirm={() => {
        dispatch(journeyDataActions.setIsAdditionalServicePlanAdded(false));
        setIsShow(false);
      }}
      onClose={() => {
        setIsShow(false);
      }}
      shown={isShown}
      title={t('additionalServicePlan:additionalServicePlanModal.title')}
    >
      {t('additionalServicePlan:additionalServicePlanModal.modalBody')}
    </Modal>
  );
};
